import { useModalStore } from 'hooks/stores/useModalStore'
import { Modal as AntModal } from 'antd'

export const GlobalModal = () => {
  const { openModal, closeModal, ...modalInfo } = useModalStore()

  if (!modalInfo.modal) {
    return null
  }

  // Modals can also use custom modals (like components/Modal/Modal.tsx) instead of Antd.Modal
  if (modalInfo.customModal) {
    return <modalInfo.modal {...modalInfo.modalProps} closeModal={closeModal} />
  }

  return (
    <AntModal centered visible onCancel={closeModal} onOk={closeModal} {...modalInfo.modalOptions}>
      <modalInfo.modal {...modalInfo.modalProps} closeModal={closeModal} />
    </AntModal>
  )
}
